import React from "react"
import { useSelector } from "react-redux"
// Components
import PageImage from "../PageImage/PageImage"
// Data
import { pages as data } from "../../data"
// Styles
import { Container } from "./PageImages.styles"

const PageImages = () => {
   const language = useSelector((state) => state.environment.language)

   let pages = []
   for (let i = 0; i < data.length; i++) {
      pages.push({
         id: data[i].id,
         title: language === "fr" ? data[i].titleFr : data[i].titleEn,
         img: data[i].img,
         link: data[i].link,
      })
   }

   return (
      <Container>
         {pages.map((item) => (
            <PageImage item={item} key={item.id} />
         ))}
      </Container>
   )
}

export default PageImages
